// @flow
// @flow-runtime warn
import { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { api, requestsGeneral } from 'app/api';
import type { PriceDiscountedRequestResult, PriceDiscountedRequestParams } from 'app/common/api/general.types/tariff.pricediscounted';


export default function usePriceDiscounted(
  params: PriceDiscountedRequestParams | null,
  autoload: boolean = true
) {
  const { t } = useTranslation('tariff');
  const [loading, setLoading] = useState(true);
  const [price, setPrice] = useState<string | null>(null);

  const handleRequest = useCallback(async () => {
    setLoading(true);
    const priceRes: PriceDiscountedRequestResult | null = await api.request(
      requestsGeneral.Tariff_GET_price_discounted, {
        error: t('tariff_get_price_discounted_error'),
        params,
      }
    );
    setLoading(false);
    setPrice(priceRes);
  }, [params, t]);

  useEffect(() => {
    if (autoload && params) {
      handleRequest();
    }
  }, [params, autoload]); // eslint-disable-line react-hooks/exhaustive-deps

  return [price, loading];
}
